import { render } from "./ProjectOverviewPage.vue?vue&type=template&id=665d8e2b&scoped=true"
import script from "./ProjectOverviewPage.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewPage.vue?vue&type=script&lang=js"

import "./ProjectOverviewPage.vue?vue&type=style&index=0&id=665d8e2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665d8e2b"]])

export default __exports__